import { pdfjs } from "react-pdf";

let configured = false;

/**
 * Configure pdf.js worker for react-pdf.
 * - Production/staging: same-origin /pdf.worker.min.js (.js MIME is reliable on static hosts)
 * - Local dev: webpack bundles the worker via import.meta.url
 * - Fallback: unpkg CDN matched to pdfjs.version
 */
export function setupPdfWorker() {
	if (configured) return;
	configured = true;

	const cdnWorker = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
	const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
	const publicWorker = `${base}/pdf.worker.min.js`;

	if (process.env.NODE_ENV === "production") {
		pdfjs.GlobalWorkerOptions.workerSrc = publicWorker;
	} else {
		try {
			pdfjs.GlobalWorkerOptions.workerSrc = new URL(
				"pdfjs-dist/build/pdf.worker.min.mjs",
				import.meta.url
			).toString();
		} catch {
			pdfjs.GlobalWorkerOptions.workerSrc = cdnWorker;
		}
	}

	// If same-origin worker 404s (old deploy), react-pdf logs a warning; CDN can be set manually:
	if (!pdfjs.GlobalWorkerOptions.workerSrc) {
		pdfjs.GlobalWorkerOptions.workerSrc = cdnWorker;
	}
}

export function getPdfWorkerFallbackUrl() {
	return `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}
